import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import UsersProfileDatatableHandler from '../containers/datatables/UsersProfileDatatableHandler/UsersProfileDatatableHandler';
import UsersProfileFormHandler from '../containers/formHandlers/UsersProfileFormHandle/UsersProfileFormHandler';
import UsersProfileFormModal from '../modals/UsersProfileFormModal';

export default function UsersProfile() {
  return (
    <>
      <CC.Heading as="h2" size="lg">
        Profil des utilisateurs
      </CC.Heading>

      <CC.Box>
        <UsersProfileFormModal />

        <CC.Box p={{ md: 4 }}>
          <CC.Text>Filtre</CC.Text>
          <CC.Box>
            <UsersProfileFormHandler />
          </CC.Box>

          <CC.Box mt="10">
            {/* <CustomReactTable data={data} columns={columns} /> */}
            <UsersProfileDatatableHandler />
          </CC.Box>
        </CC.Box>
      </CC.Box>
    </>
  );
}
